import { Button } from '../../..'
import { setFilter } from '../../../../actions/filters'
import { defineMessages, useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { selectFilter } from '../../../../store/selectors/filters'

import styles from './LoadMoreListings.module.scss'
import { RootState } from '../../../../store'
import { FilterProperties } from '../../../../types/filtersTypes'

export const MSG = defineMessages({
  loadMore: {
    id: 'General.loadMore',
    defaultMessage: 'Load More',
  },
})

export const LoadMoreListings = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const filter = useSelector<RootState, FilterProperties>(selectFilter)

  return (
    <div className={styles.loadMore}>
      <Button
        primary
        type='submit'
        onClick={() => dispatch(setFilter({ page: filter.page + 1 }))}
      >
        {intl.formatMessage(MSG.loadMore)}
      </Button>
    </div>
  )
}
